import {Routes} from '@angular/router'
import scriptsRoutes from './ui/scripts/scripts.routes'
import {ROUTE_SOURCES} from './application/constants'
import loginRoutes from './ui/login/login-routes'
import sourcesRoutes from './ui/sources/sources.routes'

export const routes: Routes = [
  ...scriptsRoutes,
  ...sourcesRoutes,
  ...loginRoutes,
  {
    path: '**',
    redirectTo: ROUTE_SOURCES
  }
]
